import { accommodationURL, bookingURL } from "../helpers/paths";
import { bannerVideo, bannerVideoMb, images } from "../source";

// HOMEPAGE DATA

export const bannerData = [
  {
    id: 1,
    type: "video",
    video: bannerVideo,
    mbVideo: bannerVideoMb,
    banImg: images.banner01.image,
    alt: images.banner01.alt,
  },
  // {
  //   id: 2,
  //   type: "image",
  //   banImg: images.banner01.image,
  //   alt: images.banner01.alt,
  // },
  // {
  //   id: 3,
  //   type: "image",
  //   banImg: images.banner01.image,
  //   alt: images.banner01.alt,
  // },
  // {
  //   id: 4,
  //   type: "image",
  //   banImg: images.banner01.image,
  //   alt: images.banner01.alt,
  // },
];

export const uspData = [
  {
    id: 1,
    row: 1,
    img: images.why01.image,
    mbImg: images.mbWhy01.image,
    title: "Integrated Campus",
    description:
      "Aiming to cultivate well-rounded individuals who can think critically, adapt to new situations, and contribute positively to society.",
  },
  {
    id: 2,
    row: 1,
    img: images.why03.image,
    mbImg: images.mbWhy03.image,
    title: "All Round Development",
    description:
      "Encompassing the development of intellectual, emotional, social, physical, and moral faculties of students.",
  },
  {
    id: 3,
    row: 1,
    img: images.why02.image,
    mbImg: images.mbWhy02.image,
    title: "Safety and Security",
    description:
      "The well-being of our residents is our top priority. Our accommodation is equipped with the latest security features, ensuring a safe and secure environment for all.",
  },
  {
    id: 4,
    row: 1,
    img: images.why06.image,
    mbImg: images.mbWhy06.image,
    title: "Sense of Community and Events",
    description:
      "Providing individuals with a support network, a source of identity and belonging, and a shared platform for collaboration, growth, and collective action.",
  },
  // {
  //   id: 5,
  //   row: 2,
  //   img: images.why05.image,
  //   title: "Laundry Services",
  //   description:
  //     "Weekly Laundry services to keep your wardrobe fresh and clean without the hassle.",
  // },
  // {
  //   id: 6,
  //   row: 2,
  //   img: images.why04.image,
  //   title: "Exceptional Food Services",
  //   description:
  //     "Savor a variety of meals including vegetarian, non-vegetarian, and Jain options, served four times a day by Sodexho caterers.",
  // },
  // {
  //   id: 7,
  //   row: 2,
  //   img: images.why07.image,
  //   title: "Safety and Security",
  //   description:
  //     "A secure environment with a focus on student safety is our top priority.",
  // },
];

export const vidData = [
  {
    id: 1,
    row: 1,
    ytLink: "https://www.youtube.com/embed/SZ3t1snaf_w?si=YqqsgIiuQJ-bn3gb",
  },
  {
    id: 2,
    row: 1,
    ytLink: "https://www.youtube.com/embed/X03yit90PWU?si=aFsFCXYZOB1n15Ql",
  },
  {
    id: 3,
    row: 1,
    ytLink: "https://www.youtube.com/embed/J5CRlsVwleM?si=M3bLO5NS9QyGwQJ1",
  },
];

export const accommodationData = [
  {
    id: 1,
    heroImg: images.accommodation01.image,
    heroMbImg: images.accommodation01mb.image,
    alt: images.accommodation01.alt,
    title: "4 Share room",
    highlights: [
      {
        icon: images.acIcon.image,
        title:
          "Centrally air-conditioned rooms with in-room temperature control",
      },
      {
        icon: images.housekeepingIcon.image,
        title: "Pantry kitchenette area on every floor with all provisions",
      },
      {
        icon: images.medicineIcon.image,
        title: "Housekeeping services",
      },
      {
        icon: images.accessIcon.image,
        title: "Facial recognition to enter accommodation floors",
      },
      // {
      //   icon: images.medicineIcon.image,
      //   title: "Medical & General accident insurance",
      // },
    ],
    description:
      "Fee starting at <strong>Rs. 54,400/-</strong> (Per month all Inclusive)",
    ctaList: [
      {
        type: "internal",
        text: "Know more",
        url: accommodationURL,
      },
      {
        type: "external",
        text: "Book now",
        url: bookingURL,
      },
    ],
  },
  // {
  //   id: 2,
  //   heroImg: images.accommodation02.image,
  //   heroMbImg: images.accommodation02mb.image,
  //   alt: images.accommodation02.alt,
  //   title: "3 Share room",
  //   highlights: [
  //     {
  //       icon: images.acIcon.image,
  //       title:
  //         "Centrally air-conditioned rooms with in-room temperature control",
  //     },
  //     {
  //       icon: images.housekeepingIcon.image,
  //       title: "Pantry kitchenette area on every floor with all provisions",
  //     },
  //     // },
  //     {
  //       icon: images.medicineIcon.image,
  //       title: "Housekeeping services",
  //     },
  //     {
  //       icon: images.accessIcon.image,
  //       title: "Facial recognition to enter accommodation floors",
  //     },
  //     // {
  //     //   icon: images.medicineIcon.image,
  //     //   title: "Medical & General accident insurance",
  //     // },
  //   ],
  //   description:
  //     "Fee starting at <strong>Rs. 60,600/-</strong> (Per month all Inclusive)",
  //   ctaList: [
  //     {
  //       type: "internal",
  //       text: "Know more",
  //       url: accommodationURL,
  //     },
  //     {
  //       type: "external",
  //       text: "Book now",
  //       url: bookingURL,
  //     },
  //   ],
  // },
  // {
  //   id: 3,
  //   heroImg: images.accommodation03.image,
  //   heroMbImg: images.accommodation03mb.image,
  //   alt: images.accommodation03.alt,
  //   title: "Twin Share room",
  //   highlights: [
  //     {
  //       icon: images.acIcon.image,
  //       title:
  //         "Centrally air-conditioned rooms with in-room temperature control",
  //     },
  //     {
  //       icon: images.housekeepingIcon.image,
  //       title: "Pantry kitchenette area on every floor with all provisions",
  //     },
  //     {
  //       icon: images.medicineIcon.image,
  //       title: "Housekeeping services",
  //     },
  //     {
  //       icon: images.accessIcon.image,
  //       title: "Facial recognition to enter accommodation floors",
  //     },
  //     // {
  //     //   icon: images.medicineIcon.image,
  //     //   title: "Medical & General accident insurance",
  //     // },
  //   ],
  //   description:
  //     "Fee starting at <strong>Rs. 72,900/-</strong> (Per month all Inclusive)",
  //   ctaList: [
  //     {
  //       type: "internal",
  //       text: "Know more",
  //       url: accommodationURL,
  //     },
  //     {
  //       type: "external",
  //       text: "Book now",
  //       url: bookingURL,
  //     },
  //   ],
  // },
];

export const homeAmenitiesData = [
  {
    id: 1,
    row: 1,
    img: images.amenities01.image,
    title: "Sense of Community and Events",
    description:
      "Play a vital role in strengthening social ties, promoting civic pride, and enhancing the quality of life.",
  },
  {
    id: 2,
    row: 1,
    img: images.amenities02.image,
    title: "Medical Assistance",
    description: "Immediate medical attention is available on-premises for your health and well-being.",
  },
  {
    id: 3,
    row: 1,
    img: images.amenities03.image,
    title: "Accommodation",
    description: "Choose from 4-share, 3-share, or twin-share rooms, all maintained with the highest standards of cleanliness.",
  },
  {
    id: 4,
    row: 2,
    img: images.amenities04.image,
    title: "Gymnasium and Indoor Sports",
    description:
      "Maintain your fitness routine with access to our well-equipped gym. Unwind and have fun with our array of indoor sports and gaming options.",
  },
  {
    id: 5,
    row: 2,
    img: images.amenities05.image,
    title: "Exceptional Food Services",
    description: "Savor a variety of meals including vegetarian, non-vegetarian, and Jain options, served four times a day by Sodexho caterers.",
  },
  // {
  //   id: 6,
  //   row: 2,
  //   img: images.amenities05.image,
  //   title: "Indoor Sports & Gaming",
  //   description:
  //     "Unwind and have fun with our array of indoor sports and gaming options.",
  // },
];

export const termsData = [
  {
    tabName: "",
    data: [
      {
        title: "",
        description:
          'Thank you for accessing/shopping at <a href="https://www.upgradliving.com/" target="_blank" rel="noopener noreferrer">https://www.upgradliving.com/</a>. This site is owned by upGrad Education Private Limited Living (ATLAS Student\u2019s Hostel) (hereinafter referred to as \u201CATLAS Student Hostel\u201D). By accessing, shopping on this site, you indicate your unconditional acceptance of these terms &amp; conditions. We reserve this right, in our sole discretion, to update or revise these terms &amp; conditions. Continued use of the site following the posting of any changes to the \u2018terms &amp; conditions\u2019, constitutes your acceptance of those changes. At <a href=\"https://www.upgradliving.com/\" target=\"_blank\" rel=\"noopener noreferrer\">https://www.upgradliving.com/</a>, we try our best to create a space where you can explore and shop for all your favorite things in a safe and secure environment. All products and information displayed on <a href=\"https://www.upgradliving.com/\" target=\"_blank\" rel=\"noopener noreferrer\">https://www.upgradliving.com/</a> constitutes an \u201Cinvitation to offer\u201D. <a href=\"https://www.upgradliving.com/\" target=\"_blank\" rel=\"noopener noreferrer\">https://www.upgradliving.com/</a> reserves the right to accept or reject your offer. Your order for purchase, constitutes your \u201Coffer\u201D which shall be subject to the terms and conditions as listed below.',
      },
      // {
      //   title: "",
      //   description: "This notice is issued by Atlas Student Hostel.",
      // },
      {
        title: "1. Eligibility to use our site",
        description:
          "Use of the Site is available only to persons who can legally enter into contracts under applicable laws. Persons who are \u201Cincompetent to contract\u201D, within the meaning of the Indian Contract Act, 1872 including un-discharged insolvents etc. are not eligible to use the Site. <a href=\"https://www.upgradliving.com/\" target=\"_blank\" rel=\"noopener noreferrer\">https://www.upgradliving.com/</a> reserves the right to terminate your access to the Site if it discovers that you are under the age of 18 years or suffers from any other disability, as recognized under Indian Contract Act, 1872.",
      },
      {
        title: "2. Membership",
        description:
          "Although it\u2019s not essential to have an account to shop with <a href=\"https://www.upgradliving.com/\" target=\"_blank\" rel=\"noopener noreferrer\">https://www.upgradliving.com/</a>, you can shop as a guest. As a member, you agree to provide true, accurate, current, and complete information about yourself as prompted by the site\u2019s registration form. Registration where prohibited under any law shall be void. <a href=\"https://www.upgradliving.com/\" target=\"_blank\" rel=\"noopener noreferrer\">https://www.upgradliving.com/</a> reserves the right to revoke or terminate your registration for any reason at any time, without notice.",
      },
      {
        title: "3. Electronic Communications",
        description:
          "When you use the site or send emails or other data, information or communicate to us, you agree and understand that you are communicating with us electronically and give your consent to receive communications electronically from us periodically, when required.",
      },
      {
        title: "4. Reviews, Feedback, Submissions",
        description:
          "All reviews, comments, feedback, postcards, suggestions, ideas, and other submissions disclosed, submitted or offered to <a href=\"https://www.upgradliving.com/\" target=\"_blank\" rel=\"noopener noreferrer\">https://www.upgradliving.com/</a> directly or otherwise disclosed, submitted or offered in connection with your use of this Site (collectively referred to \u201CComments\u201D) will remain <a href=\"https://www.upgradliving.com/\" target=\"_blank\" rel=\"noopener noreferrer\">https://www.upgradliving.com/</a> property. Such disclosure, submission or offer of any comments shall constitute an assignment to <a href=\"https://www.upgradliving.com/\" target=\"_blank\" rel=\"noopener noreferrer\">https://www.upgradliving.com/</a> of all worldwide rights, titles and interests in all copyrights and other intellectual properties in the comments, thus, it exclusively owns all such rights, titles and interests and shall not be limited in any way in its use, commercial or otherwise. <a href=\"https://www.upgradliving.com/\" target=\"_blank\" rel=\"noopener noreferrer\">https://www.upgradliving.com/</a> will be entitled to use, reproduce, disclose, modify, adapt, create derivative works from, publish, display and distribute any comments you submit for any purpose whatsoever, without restriction and without compensating you in any way. <a href=\"https://www.upgradliving.com/\" target=\"_blank\" rel=\"noopener noreferrer\">https://www.upgradliving.com/</a> is and shall be under no obligation (1) to maintain any Comments in confidence; or (2) to pay you any compensation for any Comments; or (3) to respond to any Comments. You agree that any comments submitted by you to the Site will not violate this policy or any right of any third party, including copyright, trademark, privacy or other personal or proprietary right(s), and will not cause injury to any person or entity. You further agree that no comments submitted by you to the site will be libelous or otherwise unlawful, threatening, abusive or obscene material, or contain software viruses, political campaigning, commercial solicitation, chain letters, mass mailings or any form of \u201Cspam\u201D. <a href=\"https://www.upgradliving.com/\" target=\"_blank\" rel=\"noopener noreferrer\">https://www.upgradliving.com/</a> does not regularly review posted comments, but does reserve the right (but not the obligation) to monitor and edit or remove any comment submitted to the Site. You grant <a href=\"https://www.upgradliving.com/\" target=\"_blank\" rel=\"noopener noreferrer\">https://www.upgradliving.com/</a> the right to use the name that you submit in connection with any of the posted comments. You agree not to use a false email address, impersonate any person or entity, or otherwise mislead as to the origin of any Comments you submit. You are and shall remain solely responsible for the content of any comments you make and you agree to indemnify <a href=\"https://www.upgradliving.com/\" target=\"_blank\" rel=\"noopener noreferrer\">https://www.upgradliving.com/</a> and its affiliates for all claims resulting from any Comments you submit, we take no responsibility and assume no liability for any comments submitted by you or any third party.",
      },
      // {
      //   title: "",
      //   description:
      //     "<strong>Consent to processing your data</strong><br /><br />An integral part of the ATLAS Student Hostel Platform entails the collection, processing, transmission and disclosure of Your Data by ATLAS Student Hostel and its affiliates, and you hereby specifically consent to:<br /><br />Atlas Student Home’s provision of Your Data to any Atlas Student Hostel Partner, VAS agencies, partner organizations, professional bodies, service providers to Atlas Student Hostel (including our accommodation providers and payment processors) as part of the provision of the Atlas Student Hostel Solution to you, and Governmental or Regulatory Authorities; communications from Atlas Student Hostel (including all communication channels including e-mail communications, business WhatsApp, iMessage & other marketing and informational tools) respecting the Atlas Student Hostel Solution, and Atlas Student Hostel platform products and services; and collection, use and other processing activities as set out in Atlas Student Hostel ’s Privacy Policy<br /><br />Your Personal Information will be handled in accordance with ATLAS Student Hostel ’s Privacy and Cookies Policy.<br /><br />Storage of Your Data in Other Jurisdictions You acknowledge that, due to the nature of the ATLAS Student Hostel being a facilitator, Your Data uploaded to the ATLAS Student Hostel Platform may be hosted on servers residing in jurisdictions other than India, over which ATLAS Student Hostel has no direct control. By using the ATLAS Student Hostel Solution, Your Data may become, during the period that Your Data is hosted on such servers, subject to the Applicable Laws of the jurisdiction in which such servers reside or to the terms of agreements respecting the hosting of data on such servers.",
      // },
      {
        title: "5. Accuracy of Content / Information of Products on the Web Site",
        description:
          "While <a href=\"https://www.upgradliving.com/\" target=\"_blank\" rel=\"noopener noreferrer\">https://www.upgradliving.com/</a> strives to provide accurate product and pricing information, typographical errors may occur. In the event that a product is listed at an incorrect price or with incorrect information due to an error in pricing or product information, <a href=\"https://www.upgradliving.com/\" target=\"_blank\" rel=\"noopener noreferrer\">https://www.upgradliving.com/</a> shall have the right, on our sole discretion, to modify the price of the products, or information of the products or to refuse or cancel any orders placed for that product, unless the product has already been dispatched. In the event.<br /><br />This website is designed, developed, and maintained by upGrad Education Private Limited Living (ATLAS Student\u2019s Hostel) and will be referred to as \u201CATLAS Student Hostel,\u201D \u201CWe,\u201D \u201Cour,\u201D and \u201Cus\u201D in this policy document. The content on this website is provided solely for informational purposes for all stakeholders and the general public. While we make every effort to ensure the accuracy and relevance of the information presented on this website, it should not be construed as a legal statement or document, nor can it be used for legal purposes. Users encountering queries or ambiguity are advised to seek professional advice from relevant authorities or departments. Your engagement with our site is subject to the terms and conditions listed below.<br /><br />Access to our website is available to individuals who can legally enter into contracts under applicable laws. We reserve the right to terminate access to the site if it is found that you do not meet the eligibility criteria.<br /><br />When you use the site or send emails or other data, information or communicate to us, you agree and understand that you are communicating with us electronically and give your consent to receive communications electronically from us periodically, when required.<br /><br />Submissions encompass various forms of content contributed to the ATLAS Student Hostel website, including reviews, comments, feedback, postcards, suggestions, and ideas. These materials, collectively referred to as \u201CSubmissions,\u201D are any content disclosed, submitted, or offered directly or indirectly in connection with the use of the website. By submitting any material, individuals agree to transfer all rights and interests, including copyrights and intellectual properties, to ATLAS Student Hostel. This grants the company the exclusive right to use, reproduce, modify, and distribute the Submissions without restriction or compensation. It\u2019s essential that Submissions comply with applicable laws and do not infringe on any third-party rights. While the company does not regularly review Submissions, it reserves the right to monitor and edit them. Contributors are solely responsible for the content of their Submissions and agree to indemnify ATLAS Student Hostel for any claims arising from them.<br /><br />All information contained herein has been obtained by ATLAS Student Hostel from sources believed by it to be accurate and reliable. Although reasonable care has been taken to ensure that the information herein is true, such information is provided \u2018as is\u2019 without any warranty of any kind, and ATLAS Student Hostel, in particular, makes no representation or warranty, express or implied, as to the accuracy, timeliness, or completeness of any such information. All information contained herein must be construed solely as statements of opinion, and ATLAS Student Hostel shall not be liable for any losses incurred by users from any use of its content.<br /><br />Copyright and Trademarks: All content and marks on the website are the copyright of upGrad Education Private Limited Living (ATLAS Student\u2019s Hostel), all rights reserved. Reproduction of any content in part or full from this website, modification, distribution, or republication, or otherwise use for any public or commercial purpose without prior permission from ATLAS Student Hostel is prohibited.<br /><br />Prior permission is necessary before creating hyperlinks from any website to this site. Permission must be obtained, specifying the content nature on the pages from which the link originates and the exact language of the hyperlink.<br /><br />For any copyright infringement concerns or requests related to the content on this website, please contact us at legal@upgradliving.com. We will promptly investigate and take appropriate action in accordance with applicable laws and regulations.<br /><br />The information posted on this website may contain hypertext links or pointers to information created and maintained by third-party organizations. ATLAS Student Hostel provides these links and pointers solely for your information and convenience. When you select a link to an external website, you will leave the ATLAS Student Hostel website and be subject to the privacy and security policies of the owners or sponsors of those external websites. ATLAS Student Hostel does not guarantee the availability of such linked pages at all times, nor can it authorize the use of copyrighted materials contained in linked websites. Additionally, ATLAS Student Hostel does not guarantee the availability or accuracy of such linked pages at all times.<br /><br />ATLAS Student Hostel is in no way liable for any direct, indirect, special, punitive, incidental, exemplary, or consequential damages, whether in an action under contract, negligence, or any other theory arising out of or in connection with the use, inability to use, use &amp; loss of data or performance of the information, products, services, contents, or materials on this website.<br /><br />The contents of this website are subject to change without prior notice from ATLAS Student Hostel. ATLAS Student Hostel will not be held responsible for any inadvertent errors or inaccuracies that may occur.<br /><br />This agreement shall be governed by and construed in accordance with the laws of the state of Maharashtra, India. Any dispute arising under these terms and conditions shall be subject to the exclusive jurisdiction of the courts of Maharashtra, India.<br /><br />This terms &amp; conditions was last updated on 20 February, 2024.<br /><br />This website is designed, developed, and maintained by upGrad Education Private Limited Living (ATLAS Student\u2019s Hostel) and will be referred to as \u201CATLAS Student Hostel,\u201D \u201CWe,\u201D \u201Cour,\u201D and \u201Cus\u201D in this policy document. The content on this website is provided solely for informational purposes for all stakeholders and the general public. While we make every effort to ensure the accuracy and relevance of the information presented on this website, it should not be construed as a legal statement or document, nor can it be used for legal purposes. Users encountering queries or ambiguity are advised to seek professional advice from relevant authorities or departments. Your engagement with our site is subject to the terms and conditions listed below.<br /><br />Access to our website is available to individuals who can legally enter into contracts under applicable laws. We reserve the right to terminate access to the site if it is found that you do not meet the eligibility criteria.<br /><br />When you use the site or send emails or other data, information or communicate to us, you agree and understand that you are communicating with us electronically and give your consent to receive communications electronically from us periodically, when required.<br /><br />Submissions encompass various forms of content contributed to the ATLAS Student Hostel website, including reviews, comments, feedback, postcards, suggestions, and ideas. These materials, collectively referred to as \u201CSubmissions,\u201D are any content disclosed, submitted, or offered directly or indirectly in connection with the use of the website. By submitting any material, individuals agree to transfer all rights and interests, including copyrights and intellectual properties, to ATLAS Student Hostel. This grants the company the exclusive right to use, reproduce, modify, and distribute the Submissions without restriction or compensation. It\u2019s essential that Submissions comply with applicable laws and do not infringe on any third-party rights. While the company does not regularly review Submissions, it reserves the right to monitor and edit them. Contributors are solely responsible for the content of their Submissions and agree to indemnify ATLAS Student Hostel for any claims arising from them.<br /><br />All information contained herein has been obtained by ATLAS Student Hostel from sources believed by it to be accurate and reliable. Although reasonable care has been taken to ensure that the information herein is true, such information is provided \u2018as is\u2019 without any warranty of any kind, and ATLAS Student Hostel, in particular, makes no representation or warranty, express or implied, as to the accuracy, timeliness, or completeness of any such information. All information contained herein must be construed solely as statements of opinion, and ATLAS Student Hostel shall not be liable for any losses incurred by users from any use of its content.<br /><br />Copyright and Trademarks: All content and marks on the website are the copyright of upGrad Education Private Limited Living (ATLAS Student\u2019s Hostel), all rights reserved. Reproduction of any content in part or full from this website, modification, distribution, or republication, or otherwise use for any public or commercial purpose without prior permission from ATLAS Student Hostel is prohibited.<br /><br />Prior permission is necessary before creating hyperlinks from any website to this site. Permission must be obtained, specifying the content nature on the pages from which the link originates and the exact language of the hyperlink.<br /><br />For any copyright infringement concerns or requests related to the content on this website, please contact us at legal@upgradliving.com. We will promptly investigate and take appropriate action in accordance with applicable laws and regulations.<br /><br />The information posted on this website may contain hypertext links or pointers to information created and maintained by third-party organizations. ATLAS Student Hostel provides these links and pointers solely for your information and convenience. When you select a link to an external website, you will leave the ATLAS Student Hostel website and be subject to the privacy and security policies of the owners or sponsors of those external websites. ATLAS Student Hostel does not guarantee the availability of such linked pages at all times, nor can it authorize the use of copyrighted materials contained in linked websites. Additionally, ATLAS Student Hostel does not guarantee the availability or accuracy of such linked pages at all times.<br /><br />ATLAS Student Hostel is in no way liable for any direct, indirect, special, punitive, incidental, exemplary, or consequential damages, whether in an action under contract, negligence, or any other theory arising out of or in connection with the use, inability to use, use &amp; loss of data or performance of the information, products, services, contents, or materials on this website.<br /><br />The contents of this website are subject to change without prior notice from ATLAS Student Hostel. ATLAS Student Hostel will not be held responsible for any inadvertent errors or inaccuracies that may occur.<br /><br />This agreement shall be governed by and construed in accordance with the laws of the state of Maharashtra, India. Any dispute arising under these terms and conditions shall be subject to the exclusive jurisdiction of the courts of Maharashtra, India.<br /><br />This terms &amp; conditions was last updated on 22 February, 2024.",
      },
      // {
      //   title: "",
      //   description: `<strong>What Information Do We Collect About You?</strong><br /><br />We collect information about you when you register with us or make an enquiry about our accommodation. You may provide us with personal information when communicating with ATLAS Student Home to complete a registration form, submit your interest for a Property, sign up for additional services or if you contact us with a query or complaint.<br /><br />Hostel for Students may collect information when you order a product or service and you give us personal information such as your name, email address, address, telephone number, credit or debit card number, relevant bank details or other relevant information. When you provide us with details of credit, debit or bank account details in order to make payments to us, any such information will only be used for the specific purpose for which it is provided.<br /><br />We will collect information when you voluntarily complete customer surveys, provide feedback and participate in competitions. ATLAS Student Hostel will collect information about your preferences and by analysis of customer traffic. Website usage information is collected using cookies.<br /><br />ATLAS Student Hostel may also collect information that is classed as sensitive personal data, such as ethnicity, religion, sexuality and health. Such information will only be collected with your express consent.<br /><br />How Will We Use This Information About You?<br /><br />We collect information about you to process your application for a tenancy with us, manage your account and, if you agree, to email you about services we think may be of interest to you.
      //      <br /><br/>We use your information for the following purposes:<br /><br /><ul><li>To process your application for a tenancy;</li><li>To administer your tenancy;</li> <li>To communicate with you and respond to your requests;</li> <li>To process payments;</li> <li>To recover any unpaid sums due to us;</li> <li>To prevent and detect criminal activity, fraud and misuse of or damage to our property;</li> <li>To invite you to participate in our consumer satisfaction surveys or research groups;</li><li> Where we have your consent to do so, to contact you about other products and services that we think may be of interest to you.</li></ul>
      //     `,
      // },
      // {
      //   title: "",
      //   description:
      //     "How Will We Use This Information About You?<br /><br />We collect information about you to process your application for a tenancy with us, manage your account and, if you agree, to email you about services we think may be of interest to you.",
      // },
      // {
      //   title: "",
      //   description:
      //     "We use your information for the following purposes:<br /><br /><ul><li>To process your application for a tenancy;</li><li>To administer your tenancy;</li> <li>To communicate with you and respond to your requests;</li> <li>To process payments;</li> <li>To recover any unpaid sums due to us;</li> <li>To prevent and detect criminal activity, fraud and misuse of or damage to our property;</li> <li>To invite you to participate in our consumer satisfaction surveys or research groups;</li><li> Where we have your consent to do so, to contact you about other products and services that we think may be of interest to you.</li></ul>",
      // },
    ],
  },
];

export const privacyData = [
  {
    heading: "",
    description:
      "upGrad Education Private Limited Living (ATLAS Student’s Hostel) takes your data privacy seriously and has in place the following privacy statements in order to clearly set out how ATLAS Student’s Hostel collects and utilizes the information you provide to us.<br /><br />To ensure we're providing you with the best possible student experience, we collect your data whether you fill out a form on our website, submit an application for housing, contact us via phone, email, or in-person, or live in one of our student residences.<br /><br />Our privacy policies explain why we gather information, what we do with it, how we preserve it, and with whom we might share it. We have privacy statements for each step of our connection with you since we gather distinct kinds of data at each one. To make sure you understand how information about you will be used, kindly take the time to read our privacy policies.:<br /><br /><ul><li>Enquiring, registering and applying for a room</li><li>Tenancy Agreements & living with ATLAS Student’s Hostel</li><li>Guarantors</li></ul><br />Your privacy is important to us, and we take that responsibility seriously. This privacy statement describes how we use and disclose the personal data we have acquired about you as well as how you may exercise your rights in connection with that data. According to government policy, ATLAS Student's Hostel is registered and protects your data.",
  },
];

// ABOUT US DATA

export const aboutBannerData = [
  {
    id: 1,
    banImg: images.aboutBanner.image,
    mbBanImg: images.mbAboutBanner.image,
    alt: images.aboutBanner.alt,
  },
];

export const aboutValuesData = [
  {
    id: 1,
    img: images.value01.image,
    mbImg: images.mbValue01.image,
    title: "Holistic Learning",
    description:
      "Aiming to cultivate well-rounded individuals who can think critically, adapt to new situations, and contribute positively to society.",
  },
  {
    id: 2,
    img: images.value02.image,
    mbImg: images.mbValue02.image,
    title: "All Round Development",
    description:
      "Encompassing the development of intellectual, emotional, social, physical, and moral faculties of students.",
  },
  {
    id: 3,
    img: images.value03.image,
    mbImg: images.mbValue03.image,
    title: "Safety and Security",
    description:
      "The well-being of our residents is our top priority. Our accommodations are equipped with the latest security features, ensuring a safe and secure environment for all.",
  },
  {
    id: 4,
    img: images.value04.image,
    mbImg: images.mbValue04.image,
    title: "Sense of Community and Events",
    description:
      " Providing individuals with a support network, a source of identity and belonging, and a shared platform for collaboration, growth, and collective action.",
  },
];

// AMENITIES DATA

export const amenitiesBannerData = [
  {
    id: 1,
    banImg: images.amenityBanner.image,
    mbBanImg: images.mbAmenityBanner.image,
    alt: images.amenityBanner.alt,
  },
];

export const amenitiesData = [
  {
    column: 1,
    img: images.amenity01.image,
    mbImg: images.mbAmenity01.image,
    title: "Unwind Lounge",
    desc: "Relax and recharge in our Unwind Lounge, a serene space designed for contemplation and relaxation, embodying the essence of our integrated campus philosophy.",
  },
  // {
  //   column: 2,
  //   img: images.amenity02.image,
  //   mbImg: images.mbAmenity02.image,
  //   title: "Coffee Barista",
  //   desc: "Enjoy artisanal coffee crafted by our skilled baristas, a perfect spot for informal learning and networking within our integrated campus setting. (Coming Soon)",
  // },
  {
    column: 3,
    img: images.amenity03.image,
    mbImg: images.mbAmenity03.image,
    title: "Courtyard",
    desc: "Our Courtyard is the heart of campus life, designed to encourage outdoor learning and socializing in a beautifully landscaped environment.",
  },
  {
    column: 1,
    img: images.amenity04.image,
    mbImg: images.mbAmenity04.image,
    title: "Collaborative Corridor",
    desc: "Every corridor is an opportunity for interaction. Our Collaborative Corridors are designed to promote spontaneous discussions and idea exchanges.",
  },
  {
    column: 2,
    img: images.amenity05.image,
    mbImg: images.mbAmenity05.image,
    title: "Gymnasium & Fitness Studio",
    desc: "Stay fit and healthy with our fully equipped Gymnasium and Fitness Studio, supporting the physical well-being of our community members.",
  },
  {
    column: 3,
    img: images.amenity06.image,
    mbImg: images.mbAmenity06.image,
    title: "Multisport Turf",
    desc: "Engage in various sports activities on our Multisport Turf, fostering teamwork and physical fitness in an integrated campus environment.",
  },
  {
    column: 1,
    img: images.amenity07.image,
    mbImg: images.mbAmenity07.image,
    title: "Indoor Games",
    desc: "Our indoor games area offers a variety of games, promoting strategic thinking and relaxation in a community-focused setting.",
  },
  {
    column: 2,
    img: images.amenity08.image,
    mbImg: images.mbAmenity08.image,
    title: "Community Study & Group Study Space",
    desc: "Collaborate and learn in our Community Study spaces and Group Study Space, designed to support academic excellence and group projects.",
  },
  {
    column: 3,
    img: images.amenity09.image,
    mbImg: images.mbAmenity09.image,
    title: "Coworking Spaces",
    desc: "Embrace the future of work in our Coworking Spaces, equipped with all the amenities needed for productive collaboration and innovation.",
  },
  {
    column: 1,
    img: images.amenity10.image,
    mbImg: images.mbAmenity10.image,
    title: "Perimeter Security & Daily Housekeeping",
    desc: "Your safety and comfort are our top priorities. Enjoy peace of mind with our comprehensive Perimeter Security and Daily Housekeeping services.",
  },
  // {
  //   column: 2,
  //   img: images.amenity11.image,
  //   mbImg: images.mbAmenity11.image,
  //   title: "Laundry Service & Insurance",
  //   desc: "Experience convenience with our on-site Laundry Service provided to you weekly.",
  // },
  // {
  //   column: 2,
  //   img: images.amenity13.image,
  //   mbImg: images.mbAmenity13.image,
  //   title: "First Aid Supply",
  //   desc: "Quick access to First Aid Supplies across the campus ensures that minor health issues can be addressed promptly.",
  // },
  {
    column: 2,
    img: images.amenity13.image,
    mbImg: images.mbAmenity13.image,
    title: "Medical Team & Care Network",
    desc: "Our Medical Team and Care Network ensure that health and wellness support is always within reach, reflecting our commitment to a holistic integrated campus experience.",
  },
  {
    column: 2,
    img: images.amenity14.image,
    mbImg: images.mbAmenity14.image,
    title: "Breakout Zones",
    desc: "Escape the daily grind on every floor with our cozy breakout zones. Chill with friends, unwind, and recharge in comfort.",
  },
  {
    column: 3,
    img: images.amenity15.image,
    mbImg: images.mbAmenity15.image,
    title: "Community Living",
    desc: "A unique way of organizing residential spaces that prioritizes social connection, cooperation, and shared experiences and enriching the lives of residents.",
  },
  {
    column: 1,
    img: images.amenity16.image,
    mbImg: images.mbAmenity16.image,
    title: "Events",
    desc: "Our events serve various purposes, including promoting social interaction, fostering academic and personal growth, celebrating diversity, and enhancing the overall college experience.",
  },
  {
    column: 2,
    img: images.amenity17.image,
    mbImg: images.mbAmenity17.image,
    title: "Pantry Area",
    desc: "Pantry area on each floor to store your delicious food and beverages and have a quick snack.",
  },
  {
    column: 3,
    img: images.amenity18.image,
    mbImg: images.mbAmenity18.image,
    title: "Vending Machine",
    desc: "A quick and easy way to purchase snacks, beverages, and other items on-the-go.",
  },
];

// DINING US DATA

export const diningBannerData = [
  {
    id: 1,
    banImg: images.diningBanner.image,
    mbBanImg: images.mbDiningBanner.image,
    alt: images.diningBanner.alt,
  },
];

export const diningValuesData = [
  {
    id: 1,
    img: images.diningCard01.image,
    mbImg: images.mbDiningCard01.image,
    title: "Breakfast",
    description:
      "Hot snacks, Live omelet counter, fruits, cereal & hot beverages.",
  },
  {
    id: 2,
    img: images.diningCard02.image,
    mbImg: images.mbDiningCard02.image,
    title: "Lunch",
    description:
      "Customised menus based on Indian, Asian, Mexican & Continental cuisines.",
  },
  {
    id: 3,
    img: images.diningCard03.image,
    mbImg: images.mbDiningCard03.image,
    title: "High Tea & Snacks",
    description: "Evening snacks and beverages.",
  },
  {
    id: 4,
    img: images.diningCard04.image,
    mbImg: images.mbDiningCard04.image,
    title: "Dinner",
    description:
      "Customised menus based on Indian, Asian, Mexican & Continental cuisines.",
  },
];

// STUDENT LIFE DATA

export const studentLifeBannerData = [
  {
    id: 1,
    banImg: images.studentBanner.image,
    mbBanImg: images.mbStudentBanner.image,
    alt: images.studentBanner.alt,
  },
];

export const studentLifeData = [
  {
    img: images.morningWorkouts.image,
    mbImg: images.mbMorningWorkouts.image,
    title: "Morning Workouts",
    desc: "Our day begins with the sun peering through, beckoning us to the state-of-the-art fitness facilities. Here, students find their zen or pump up their energy levels, preparing themselves for the day ahead with morning workouts that invigorate both mind and body.",
  },
  {
    img: images.classroomMinute.image,
    mbImg: images.mbClassroomMinute.image,
    title: "Classroom in A Minute",
    desc: "With our integrated campus design, the transition from leisure to learning is seamless. Classrooms are just a minute away, embodying our commitment to accessibility and efficiency. This proximity ensures that students can make the most of their time, focusing on their studies without the hassle of long commutes.",
  },
  {
    img: images.breakfastDone.image,
    mbImg: images.mbBreakfastDone.image,
    title: "Breakfast done the Mumbai way",
    desc: "Breakfast at ATLAS is an experience in itself, offering a taste of Mumbai with a variety of local flavors. It’s more than just a meal; it’s a celebration of the city’s rich culinary heritage, ensuring students start their day nourished and ready to tackle whatever comes their way.",
  },
  {
    img: images.relaxingLunch.image,
    mbImg: images.mbRelaxingLunch.image,
    title: "Indoor Games",
    desc: "Our indoor games area offers a variety of games, promoting strategic thinking and relaxation in a community-focused setting.",
  },
  {
    img: images.studyTime.image,
    mbImg: images.mbStudyTime.image,
    title: "Study Time",
    desc: "Our well-equipped study zones are designed to foster an environment where focus and collaboration thrive. Whether it’s preparing for exams or working on group projects, students find the support and resources they need to excel.",
  },
  {
    img: images.matchTurf.image,
    mbImg: images.mbMatchTurf.image,
    title: "Cricket Turf",
    desc: "As the afternoon wanes, the turf comes alive with the spirit of competition and camaraderie. A friendly match of cricket not only celebrates our commitment to sports and wellness but also strengthens the bonds within our community.",
  },
  {
    img: images.EndingDay.image,
    mbImg: images.mbEndingDay.image,
    title: "Ending a Power-Packed Day",
    desc: "As night falls, students retire to their comfortable accommodations, reflecting on a day well spent. It’s a moment of gratitude and anticipation, recharging for another day filled with opportunities and adventures.",
  },
  {
    img: images.SplendidDinner.image,
    mbImg: images.mbSplendidDinner.image,
    title: "Splendid Meals 4 Times a Day",
    desc: "Indulge in a gastronomic journey with sumptuous meals meticulously crafted, nutritious and served four times daily, promising an exquisite dining experience that delights the senses and satisfies the palate.",
  },
  {
    img: images.weekendAdventures.image,
    mbImg: images.mbWeekendAdventures.image,
    title: "Weekend Adventures in Mumbai",
    desc: "Weekends are reserved for exploring the vibrant city of Mumbai, with its endless cultural, historical, and entertainment options. Our prime location makes it easy for students to embark on these adventures, discovering new facets of the city and themselves.",
  },
  {
    img: images.festivalCelebration.image,
    mbImg: images.mbFestivalCelebration.image,
    title: "Festival Celebrations",
    desc: "Featuring a diverse range of activities, performances, competitions, and social gatherings that bring together students, faculty, staff, alumni, and sometimes members of the local community.",
  },
  {
    img: images.movieNight.image,
    mbImg: images.mbMovieNight.image,
    title: "Movie Night",
    desc: "A fun and inclusive way for students to come together, de-stress, and enjoy a sense of community on campus.",
  },
];
